export type Anime = {
  id: string;
  title: string;
  originalTitle: string;
  type: string;
  region: string;
  year: number;
  status: "连载中" | "已完结";
  episodes: number;
  rating: number;
  views: number;
  updatedAt: string;
  serialDay: string;
  cover: string;
  tags: string[];
  summary: string;
  studio: string;
  director: string;
  chapterList: {
    index: number;
    title: string;
    duration: string;
    date: string;
    desc: string;
  }[];
};

const rawAnimeList: Anime[] = [
  {
    id: "xingkong-qishi",
    title: "星空骑士",
    originalTitle: "Starlight Rider",
    type: "科幻",
    region: "国漫",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 9.4,
    views: 12860000,
    updatedAt: "2026-10-17",
    serialDay: "每周五 20:00",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20poster%20of%20a%20young%20knight%20in%20sleek%20silver%20armor%20floating%20in%20deep%20navy%20starry%20space%2C%20glowing%20orange%20energy%20sword%2C%20dramatic%20nebula%20backdrop%2C%20high%20detail%20anime%20illustration%2C%20simple%20clean%20background%20composition&width=600&height=840&seq=anime-cover-starlight-rider&orientation=portrait",
    tags: ["机甲", "星空冒险", "热血"],
    summary:
      "在被星尘覆盖的第七星系，少年驾驶者意外唤醒了沉睡三百年的星际骑士装甲。为了寻找失踪的姐姐，他踏上穿越陨星带的旅程，而每一次跃迁都在改写整个星系的命运。",
    studio: "妖精动画制作组",
    director: "陆行舟",
    chapterList: [
      { index: 1, title: "第1话 星尘的召唤", duration: "24:16", date: "2026-09-04", desc: "少年第一次听见装甲的呼吸声，陨石带边缘的旧战场在夜色中苏醒。" },
      { index: 2, title: "第2话 断裂的航线", duration: "23:48", date: "2026-09-11", desc: "导航系统失灵，骑士团被迫降落在被遗忘的空间站。" },
      { index: 3, title: "第3话 银色的誓言", duration: "24:02", date: "2026-09-18", desc: "旧友重逢，却站在了对立的两侧。" },
      { index: 4, title: "第4话 陨星带的回声", duration: "23:55", date: "2026-09-25", desc: "穿越陨星带时，姐姐留下的信号第一次被捕获。" },
      { index: 5, title: "第5话 双星之战", duration: "24:30", date: "2026-10-02", desc: "两颗恒星交叠的一瞬，装甲觉醒了第二形态。" },
      { index: 6, title: "第6话 灯塔熄灭", duration: "24:08", date: "2026-10-09", desc: "第七星系的灯塔熄灭，返航之路彻底消失。" },
      { index: 7, title: "第7话 归零坐标", duration: "24:20", date: "2026-10-16", desc: "为了救回同伴，少年做出了违背骑士守则的选择。" },
    ],
  },
  {
    id: "qingqiu-riji",
    title: "青丘日记",
    originalTitle: "Diary of Qingqiu",
    type: "奇幻",
    region: "国漫",
    year: 2025,
    status: "已完结",
    episodes: 26,
    rating: 9.1,
    views: 9680000,
    updatedAt: "2026-10-12",
    serialDay: "全26话已完结",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20fantasy%20anime%20poster%20featuring%20a%20fox%20spirit%20girl%20in%20flowing%20ivory%20and%20orange%20robes%20standing%20in%20misty%20mountain%20forest%2C%20warm%20golden%20light%2C%20delicate%20linework%2C%20minimal%20clean%20background%20composition&width=600&height=840&seq=anime-cover-qingqiu-diary&orientation=portrait",
    tags: ["国风", "妖怪", "治愈"],
    summary:
      "青丘山下的小书铺里，住着一只会写日记的狐狸。她替人记下遗忘的故事，也在字里行间慢慢找回自己丢失的名字。一册册日记连起来，是一座城的百年温柔。",
    studio: "云上图绘",
    director: "沈素问",
    chapterList: [
      { index: 1, title: "第1话 一册空白的日记", duration: "22:40", date: "2025-04-06", desc: "书铺开张的第一天，来了一位不肯说姓名的客人。" },
      { index: 2, title: "第2话 灯会与纸鸢", duration: "23:05", date: "2025-04-13", desc: "上元灯会，狐狸第一次走进人潮。" },
      { index: 3, title: "第3话 借来的名字", duration: "22:52", date: "2025-04-20", desc: "她说出那个名字的瞬间，山里的桃花全开了。" },
      { index: 4, title: "第4话 山中书信", duration: "23:18", date: "2025-04-27", desc: "一封寄错地址的信，牵出一段被隐瞒的往事。" },
      { index: 5, title: "第5话 忘川边的灯", duration: "24:02", date: "2025-05-04", desc: "日记的最后一页，写的是她自己。" },
    ],
  },
  {
    id: "yuehai-shiguang",
    title: "月海拾光",
    originalTitle: "Moon Sea Memories",
    type: "治愈",
    region: "日漫",
    year: 2026,
    status: "连载中",
    episodes: 9,
    rating: 8.9,
    views: 7420000,
    updatedAt: "2026-10-15",
    serialDay: "每周二 22:00",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20romantic%20anime%20poster%20of%20a%20girl%20standing%20on%20a%20seaside%20train%20platform%20under%20a%20huge%20pale%20moon%2C%20gentle%20cyan%20and%20peach%20sky%2C%20light%20breeze%2C%20watercolor%20texture%2C%20minimal%20clean%20background&width=600&height=840&seq=anime-cover-moon-sea&orientation=portrait",
    tags: ["日常", "青春", "海边"],
    summary:
      "毕业那个夏天，少女回到了外婆的海边小镇。她在一家旧胶片冲洗店里发现了一卷未冲的胶卷，里面是十年前那个夏天所有人笑着的脸。拾起光的碎片，她才明白告别原来也可以很温柔。",
    studio: "月光社",
    director: "高桥绫",
    chapterList: [
      { index: 1, title: "第1话 回到海边的夏天", duration: "23:30", date: "2026-08-18", desc: "列车摇晃着穿过隧道，海的味道先到了。" },
      { index: 2, title: "第2话 冲洗店的老爷爷", duration: "23:12", date: "2026-08-25", desc: "一卷没有标记的胶卷，藏着十年前的夏天。" },
      { index: 3, title: "第3话 潮汐时刻表", duration: "23:44", date: "2026-09-01", desc: "潮水退去时，沙滩上出现了写好的信。" },
      { index: 4, title: "第4话 月海", duration: "24:00", date: "2026-09-08", desc: "满月升起，整片海面像一面镜子。" },
    ],
  },
  {
    id: "jixie-xueyuan",
    title: "机械学园Z",
    originalTitle: "Mecha Academy Z",
    type: "机甲",
    region: "日漫",
    year: 2025,
    status: "已完结",
    episodes: 24,
    rating: 9.0,
    views: 8640000,
    updatedAt: "2026-09-28",
    serialDay: "全24话已完结",
    cover:
      "https://readdy.ai/api/search-image?query=Bold%20mecha%20anime%20poster%20with%20a%20teenage%20pilot%20in%20orange%20flight%20suit%20standing%20before%20a%20towering%20white%20and%20navy%20robot%20in%20a%20hangar%2C%20industrial%20gray%20background%2C%20dramatic%20rim%20light%2C%20sharp%20anime%20illustration&width=600&height=840&seq=anime-cover-mecha-academy&orientation=portrait",
    tags: ["机战", "校园", "成长"],
    summary:
      "在专门培养驾驶者的机械学园里，成绩垫底的新生抽中了编号 Z 的旧机体。这台被淘汰的机甲，却保留着上一代战争中最强的战术记忆，也记得一段不该被公开的历史。",
    studio: "钢铁工房",
    director: "佐藤海",
    chapterList: [
      { index: 1, title: "第1话 编号Z", duration: "24:10", date: "2025-10-04", desc: "抽签的结果，让整个学园都安静了三秒。" },
      { index: 2, title: "第2话 第一次启动", duration: "23:58", date: "2025-10-11", desc: "旧机体的引擎声，像一段熟悉的心跳。" },
      { index: 3, title: "第3话 老兵的记忆", duration: "24:22", date: "2025-10-18", desc: "战术记忆里出现了一张不该存在的照片。" },
      { index: 4, title: "第4话 模拟战", duration: "24:05", date: "2025-10-25", desc: "被全校看轻的队伍，赢了第一场正式模拟战。" },
    ],
  },
  {
    id: "lingxiao-jianpu",
    title: "凌霄剑谱",
    originalTitle: "Sword Codex of Lingxiao",
    type: "武侠",
    region: "国漫",
    year: 2026,
    status: "连载中",
    episodes: 15,
    rating: 9.2,
    views: 11250000,
    updatedAt: "2026-10-18",
    serialDay: "每周六 19:00",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20wuxia%20anime%20poster%20of%20a%20swordsman%20in%20deep%20navy%20hanfu%20standing%20on%20a%20cliff%20above%20clouds%2C%20red%20orange%20maple%20leaves%20swirling%2C%20misty%20mountains%2C%20refined%20ink%20and%20digital%20painting%20blend&width=600&height=840&seq=anime-cover-lingxiao-sword&orientation=portrait",
    tags: ["武侠", "江湖", "少年"],
    summary:
      "剑谱被拆成十五页散落江湖，每一页都藏在一位绝顶高手身上。背负师门血案的少年，带着半部残卷走上凌霄阁，他要在所有人前面，把仇人的名字念完。",
    studio: "青锋工作室",
    director: "江眠",
    chapterList: [
      { index: 1, title: "第1话 残卷", duration: "24:12", date: "2026-07-11", desc: "雨夜，断剑，半页纸。" },
      { index: 2, title: "第2话 落霞渡口", duration: "23:50", date: "2026-07-18", desc: "渡口的老船夫认得那把剑。" },
      { index: 3, title: "第3话 十五页", duration: "24:18", date: "2026-07-25", desc: "江湖上第一次有人把剑谱的页数数清。" },
      { index: 4, title: "第4话 凌霄阁前", duration: "24:26", date: "2026-08-01", desc: "他站在凌霄阁前，说出了那个名字。" },
    ],
  },
  {
    id: "yasai-youeryuan",
    title: "夜色游乐园",
    originalTitle: "Night Carnival",
    type: "悬疑",
    region: "日漫",
    year: 2025,
    status: "连载中",
    episodes: 11,
    rating: 8.7,
    views: 5360000,
    updatedAt: "2026-10-11",
    serialDay: "每周三 21:00",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20anime%20poster%20of%20an%20abandoned%20amusement%20park%20at%20night%20with%20warm%20amber%20ferris%20wheel%20lights%2C%20a%20lone%20silhouette%20in%20a%20coat%2C%20deep%20navy%20sky%2C%20faint%20fog%2C%20cinematic%20anime%20illustration%20with%20clean%20composition&width=600&height=840&seq=anime-cover-night-carnival&orientation=portrait",
    tags: ["推理", "都市传说", "氛围"],
    summary:
      "凌晨零点，只在雨夜出现的游乐园会亮起霓虹。每一位入园者都能实现一个愿望，但必须留下一样东西作为交换——多数人留下的是记忆。侦探与少女在第七次入园时，终于看清了售票员的真面目。",
    studio: "夜行社",
    director: "森川佑",
    chapterList: [
      { index: 1, title: "第1话 雨夜的入口", duration: "23:36", date: "2026-08-06", desc: "零点整，售票亭的灯亮了。" },
      { index: 2, title: "第2话 一张旧票根", duration: "23:48", date: "2026-08-13", desc: "票根上的日期是还没有到来的明天。" },
      { index: 3, title: "第3话 第七次入园", duration: "24:14", date: "2026-08-20", desc: "这一次，他们记得上一次的选择。" },
    ],
  },
  {
    id: "fanxing-shitang",
    title: "繁星食堂",
    originalTitle: "Starry Diner",
    type: "日常",
    region: "国漫",
    year: 2026,
    status: "连载中",
    episodes: 18,
    rating: 8.8,
    views: 6210000,
    updatedAt: "2026-10-16",
    serialDay: "每周三 12:00",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20poster%20of%20a%20tiny%20late%20night%20diner%20with%20warm%20orange%20lantern%20light%2C%20steaming%20noodle%20bowls%20on%20a%20wooden%20counter%2C%20snowy%20street%20outside%2C%20soft%20painterly%20anime%20style%2C%20clean%20composition&width=600&height=840&seq=anime-cover-starry-diner&orientation=portrait",
    tags: ["美食", "治愈", "群像"],
    summary:
      "一间只在深夜营业的小食堂，菜单上写着三十道家常菜。老板不太会聊天，但总能端出客人真正想吃的那一碗。城市里所有失眠的人，都在这里短暂地落到地上。",
    studio: "灯火映画",
    director: "梁小满",
    chapterList: [
      { index: 1, title: "第1话 深夜的第一碗面", duration: "22:20", date: "2026-06-18", desc: "第一位客人只想吃一碗什么都不加的素面。" },
      { index: 2, title: "第2话 加一颗蛋", duration: "22:36", date: "2026-06-25", desc: "加班到凌晨的女孩，第一次点了加料。" },
      { index: 3, title: "第3话 雨天限定", duration: "22:48", date: "2026-07-02", desc: "下雨天，食堂会多一道不写在菜单上的菜。" },
    ],
  },
  {
    id: "yunhai-youxia",
    title: "云海游侠传",
    originalTitle: "Ranger of the Cloud Sea",
    type: "冒险",
    region: "国漫",
    year: 2024,
    status: "已完结",
    episodes: 40,
    rating: 9.3,
    views: 14320000,
    updatedAt: "2026-08-22",
    serialDay: "全40话已完结",
    cover:
      "https://readdy.ai/api/search-image?query=Adventurous%20anime%20poster%20of%20a%20young%20ranger%20standing%20on%20the%20deck%20of%20a%20flying%20wooden%20airship%20above%20a%20sea%20of%20clouds%2C%20golden%20sunset%20light%2C%20orange%20sails%2C%20wide%20sky%2C%20detailed%20anime%20key%20visual&width=600&height=840&seq=anime-cover-cloud-sea-ranger&orientation=portrait",
    tags: ["冒险", "成长", "奇幻"],
    summary:
      "在云海之上航行着无数商船与海盗船。少年为了寻找传说中漂浮的岛屿，加入了一支只有四个人的落魄船队。四十话的旅程里，他们找到了岛，也丢下了一些不想再带走的执念。",
    studio: "远帆动画",
    director: "程远",
    chapterList: [
      { index: 1, title: "第1话 起航", duration: "24:00", date: "2024-03-02", desc: "一艘只有四个人的船，出发去寻找天空中的岛。" },
      { index: 2, title: "第2话 云海风暴", duration: "24:08", date: "2024-03-09", desc: "在云层深处，他们第一次见到会呼吸的鲸。" },
      { index: 3, title: "第3话 浮空集市", duration: "23:52", date: "2024-03-16", desc: "集市上有人兜售一张旧地图。" },
    ],
  },
  {
    id: "xueye-xinhao",
    title: "雪夜信号",
    originalTitle: "Signal in the Snow",
    type: "科幻",
    region: "韩漫",
    year: 2026,
    status: "连载中",
    episodes: 8,
    rating: 8.6,
    views: 3980000,
    updatedAt: "2026-10-14",
    serialDay: "每周四 20:30",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20sci-fi%20anime%20poster%20of%20a%20lone%20radio%20operator%20in%20a%20snowy%20research%20station%2C%20tall%20antenna%20glowing%20soft%20cyan%2C%20deep%20navy%20night%20sky%2C%20snowflakes%2C%20cinematic%20muted%20palette%2C%20clean%20composition&width=600&height=840&seq=anime-cover-snow-signal&orientation=portrait",
    tags: ["科幻", "孤独", "末世"],
    summary:
      "一场全球性停电之后，极地观测站每天都会收到一段重复的信号。值守的女工程师逐渐听出，那段杂音里有人用摩斯电码念着她的名字。",
    studio: "白噪声工作室",
    director: "金敏书",
    chapterList: [
      { index: 1, title: "第1话 0300 频率", duration: "23:20", date: "2026-08-27", desc: "凌晨三点，接收机第一次自己亮起来。" },
      { index: 2, title: "第2话 重复的句子", duration: "23:34", date: "2026-09-03", desc: "同一句话，每天准点出现。" },
      { index: 3, title: "第3话 站外脚印", duration: "23:46", date: "2026-09-10", desc: "雪地上有一串脚印，通向没有门的地方。" },
    ],
  },
  {
    id: "hualing-geji",
    title: "花灵歌姬",
    originalTitle: "Songstress of Petals",
    type: "音乐",
    region: "日漫",
    year: 2025,
    status: "已完结",
    episodes: 13,
    rating: 8.9,
    views: 5120000,
    updatedAt: "2026-07-30",
    serialDay: "全13话已完结",
    cover:
      "https://readdy.ai/api/search-image?query=Dreamy%20anime%20poster%20of%20a%20girl%20singer%20in%20a%20flowing%20peach%20dress%20holding%20a%20microphone%20on%20a%20stage%20scattered%20with%20petals%2C%20soft%20spotlight%2C%20warm%20cream%20and%20coral%20tonal%20background%2C%20delicate%20anime%20illustration&width=600&height=840&seq=anime-cover-petal-songstress&orientation=portrait",
    tags: ["音乐", "少女", "励志"],
    summary:
      "能在歌声里看见花的少女，被一家快要关门的剧场收留。她唱的每一首歌都会让台上开出一朵花，而剧场老板欠下的最后一场演出，是她唯一的机会。",
    studio: "花瓣音乐社",
    director: "小林织",
    chapterList: [
      { index: 1, title: "第1话 会开花的歌", duration: "23:10", date: "2025-11-08", desc: "她的歌声让废弃剧场开满了花。" },
      { index: 2, title: "第2话 空座", duration: "23:22", date: "2025-11-15", desc: "第一场演出，只有一位观众。" },
    ],
  },
  {
    id: "guixu-qitan",
    title: "归墟奇谈",
    originalTitle: "Tales of Guixu",
    type: "奇幻",
    region: "国漫",
    year: 2026,
    status: "连载中",
    episodes: 20,
    rating: 9.0,
    views: 8760000,
    updatedAt: "2026-10-13",
    serialDay: "每周日 20:00",
    cover:
      "https://readdy.ai/api/search-image?query=Mystical%20Chinese%20mythology%20anime%20poster%20of%20an%20ancient%20sea%20whirlpool%20with%20glowing%20bluish%20mist%2C%20a%20figure%20in%20dark%20navy%20robes%20holding%20a%20lantern%2C%20floating%20stone%20pillars%2C%20rich%20detailed%20anime%20key%20art%2C%20clean%20composition&width=600&height=840&seq=anime-cover-guixu-tales&orientation=portrait",
    tags: ["神话", "东方奇幻", "冒险"],
    summary:
      "归墟是四海之水汇聚之地，也是所有失落之物的归处。摆渡人每日载着亡者与旧物下潜，直到某天，他在最深处见到了还在等自己的妹妹。",
    studio: "玄海映画",
    director: "宿白",
    chapterList: [
      { index: 1, title: "第1话 摆渡人", duration: "24:04", date: "2026-05-31", desc: "一叶小舟，载着沉默的乘客下潜。" },
      { index: 2, title: "第2话 沉没的钟", duration: "23:58", date: "2026-06-07", desc: "海底的钟响了七下。" },
      { index: 3, title: "第3话 最深处", duration: "24:20", date: "2026-06-14", desc: "他看见了那个一直在等的人。" },
    ],
  },
];

export const animeList: Anime[] = rawAnimeList;

export const getAnimeById = (id?: string): Anime | undefined =>
  animeList.find((item) => item.id === id);

export const getRelatedAnime = (anime: Anime, limit = 4): Anime[] =>
  animeList
    .filter((item) => item.id !== anime.id)
    .sort((a, b) => {
      const scoreA = (a.type === anime.type ? 2 : 0) + (a.region === anime.region ? 1 : 0);
      const scoreB = (b.type === anime.type ? 2 : 0) + (b.region === anime.region ? 1 : 0);
      return scoreB - scoreA;
    })
    .slice(0, limit);

export const heroAnime = animeList.filter((item) =>
  ["xingkong-qishi", "lingxiao-jianpu", "yunhai-youxia", "guixu-qitan", "yuehai-shiguang"].includes(item.id)
);

export const newsList: {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  category: string;
  author: string;
  content: { heading?: string; body: string }[];
}[] = [
  {
    id: "xingkong-qishi-ep7",
    title: "《星空骑士》第7话高能收官，导演谈“归零坐标”背后的设定",
    summary: "本周更新的第7话以23分钟高强度空间战登顶热搜，制作组首次公开了装甲第二形态的设计手稿与后续剧情走向。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20navy%20sci-fi%20anime%20illustration%20of%20a%20silver%20knight%20mecha%20flying%20through%20a%20nebula%20with%20orange%20energy%20trails%2C%20cinematic%20wide%20composition%2C%20clean%20minimal%20background%2C%20high%20detail&width=1200&height=700&seq=news-cover-starlight-ep7&orientation=landscape",
    date: "2026-10-17",
    category: "作品动态",
    author: "妖精动漫编辑部",
    content: [
      { body: "本周五晚更新的《星空骑士》第7话《归零坐标》上线两小时内播放量突破 3200 万，成为本季度单集播放增速最快的国漫作品。制作组在官方释出的幕后短片中，首次公开了本集长达四分半钟的连续空间战分镜。" },
      { heading: "导演：这一集是整季的转折点", body: "导演陆行舟在采访中提到，“归零坐标”并非单纯的战斗集，而是整季剧本里情绪最低谷的一集。少年主角在这一集做出违背骑士守则的选择，也让后续四集的故事方向发生偏移。" },
      { heading: "装甲第二形态的设计迭代了十一版", body: "美术团队透露，第二形态从概念稿到最终定稿共修改十一版，最终保留了银色装甲与橙色能量线的对比关系，以便在暗色星空中保持辨识度。" },
      { body: "官方同时确认，第8话将于 10 月 23 日晚 20:00 更新，第9话起将进入“双星之战”后篇，新的角色阵容也会陆续登场。" },
    ],
  },
  {
    id: "autumn-lineup-review",
    title: "2026 秋季新番观察：国漫科幻题材集体发力",
    summary: "本季度共有 14 部国漫新作上线，科幻与奇幻占据七成。我们从题材、制作班底和观众反馈三个维度做了盘点。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20anime%20illustration%20collage%20of%20colorful%20miniature%20anime%20scenes%20arranged%20on%20a%20deep%20navy%20background%20with%20orange%20geometric%20accents%2C%20clean%20modern%20magazine%20layout%20feel&width=1200&height=700&seq=news-cover-autumn-lineup&orientation=landscape",
    date: "2026-10-14",
    category: "行业观察",
    author: "研究员 / 林岸",
    content: [
      { body: "统计显示，2026 年秋季档上线的国产动画新作共 14 部，其中科幻与奇幻题材合计占七成，较去年同期提升约 18 个百分点。科幻题材的集中爆发，与近两年引擎渲染流程的成熟密切相关。" },
      { heading: "题材集中不代表同质化", body: "虽然都挂着“科幻”标签，但作品的内核差异明显：有的偏向机甲战斗与热血成长，有的聚焦孤独与信息传递，也有的把科幻当作温情的背景板。观众口碑榜上，这三类作品分别占据了不同年龄段的首位。" },
      { heading: "观众更在意“看完记得住”", body: "在本次抽样的一万条评论中，出现频率最高的正向关键词是“记得住”“有后劲”“角色可爱”，而单纯的特效评价占比反而在下降。这说明国产动画的受众正在从视觉驱动转向故事驱动。" },
    ],
  },
  {
    id: "qingqiu-riji-finale",
    title: "《青丘日记》完结特别篇定档，狐狸终于说出自己的名字",
    summary: "全26话完结后，制作组宣布将于11月推出30分钟特别篇，补完书铺的最后一册日记与两位主角的结局。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20Chinese%20fantasy%20anime%20illustration%20of%20a%20cozy%20old%20bookshop%20with%20glowing%20paper%20lanterns%2C%20fox%20spirit%20silhouette%20at%20the%20door%2C%20misty%20mountain%20outside%2C%20golden%20orange%20and%20ivory%20tones%2C%20cinematic%20wide%20composition&width=1200&height=700&seq=news-cover-qingqiu-finale&orientation=landscape",
    date: "2026-10-10",
    category: "档期情报",
    author: "妖精动漫编辑部",
    content: [
      { body: "《青丘日记》全26话已于上月正式完结，官方宣布将在 11 月 8 日推出一集 30 分钟的完结特别篇，为书铺的故事补上一个完整的句点。" },
      { heading: "特别篇的核心是一册空白日记", body: "原作透露，特别篇将围绕“她终于写下自己的名字”展开，这也回应了第一话那册空白日记留下的悬念。" },
      { body: "特别篇上线当日，官方还会同步推出美术设定集与广播剧，包含三章未动画化的短篇。" },
    ],
  },
  {
    id: "lingxiao-sword-15",
    title: "《凌霄剑谱》第15页现身，江湖格局迎来最大反转",
    summary: "连载第15话抛出关键线索，凌霄阁与早年血案的关联被揭开，观众讨论度在48小时内翻了三倍。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20wuxia%20anime%20illustration%20of%20a%20swordsman%20facing%20a%20vast%20cloud%20sea%20at%20dusk%2C%20flying%20petals%20and%20orange%20sunset%20light%2C%20deep%20navy%20mountain%20silhouettes%2C%20cinematic%20wide%20anime%20key%20visual&width=1200&height=700&seq=news-cover-lingxiao-ep15&orientation=landscape",
    date: "2026-10-06",
    category: "剧情解读",
    author: "专栏作者 / 苏禾",
    content: [
      { body: "《凌霄剑谱》更新至第15话，最后一页剑谱出现的位置出乎所有人意料——它就藏在凌霄阁大殿的匾额之后，而匾额正是由主角的师父题写。" },
      { heading: "为什么说这是最大的反转", body: "此前所有线索都在暗示主角的仇人是魔教中人，而本话把矛盾指向了他最信任的师门。导演江眠表示，这个反转在第一季筹备初期就已经定下，前面的每一个细节都是伏笔。" },
      { body: "下一话将进入“凌霄阁前”篇，主角需要在真相与师恩之间做一次选择。" },
    ],
  },
  {
    id: "moon-sea-music",
    title: "《月海拾光》原声带上线，八首插曲还原海边小镇的夏天",
    summary: "以钢琴与环境音为主的原声带收录八首插曲，主创分享了如何用潮汐声塑造作品的呼吸感。",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20watercolor%20anime%20illustration%20of%20a%20seaside%20town%20at%20blue%20hour%20with%20a%20pier%2C%20warm%20window%20lights%2C%20vinyl%20soundtrack%20sleeve%20aesthetic%2C%20peach%20and%20cyan%20tones%2C%20clean%20minimal%20composition&width=1200&height=700&seq=news-cover-moon-sea-ost&orientation=landscape",
    date: "2026-09-29",
    category: "音乐资讯",
    author: "音乐组 / 唐可",
    content: [
      { body: "《月海拾光》原声带正式上线，共收录八首插曲与十二段配乐。作曲团队表示，整张专辑都围绕同一个动机展开：一段四小节的钢琴旋律，在不同场景里变换速度与配器。" },
      { heading: "用潮汐声打通全片", body: "音效组在海边录制了连续 72 小时的潮汐声，剪辑成不同长度的环境底噪，让每一集的开场都拥有独立的呼吸节奏。" },
    ],
  },
  {
    id: "fanxing-diner-recipe",
    title: "《繁星食堂》联动线下快闪，三十道家常菜实景还原",
    summary: "剧中的小食堂将在三座城市开出限定快闪店，菜单与动画中的出场顺序完全一致。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20style%20illustration%20of%20a%20street%20side%20late%20night%20diner%20with%20warm%20lantern%20lights%20and%20steaming%20food%20displayed%20on%20a%20wooden%20counter%2C%20soft%20snowfall%2C%20orange%20and%20muted%20navy%20palette%2C%20cinematic%20wide&width=1200&height=700&seq=news-cover-starry-diner-popup&orientation=landscape",
    date: "2026-09-22",
    category: "活动情报",
    author: "妖精动漫编辑部",
    content: [
      { body: "《繁星食堂》官方宣布，将与三座城市的餐饮空间合作开出限定快闪店，还原剧中的深夜食堂场景，菜单完全按照动画出场顺序排列。" },
      { heading: "每一道菜都有一集故事", body: "快闪店的墙面会随菜品对应剧集切换展示分镜，客人扫码即可查看那道菜背后的故事。" },
    ],
  },
  {
    id: "mecha-academy-retro",
    title: "《机械学园Z》一周年回顾：一台旧机体如何成为年度角色",
    summary: "完结一年后，编号Z依然在角色人气榜前列。制作组复盘了机体设计与战斗演出上的取舍。",
    cover:
      "https://readdy.ai/api/search-image?query=Mecha%20anime%20illustration%20of%20a%20weathered%20white%20and%20navy%20robot%20standing%20in%20a%20dim%20hangar%20with%20orange%20spotlights%2C%20retro%20industrial%20atmosphere%2C%20cinematic%20wide%20composition%2C%20clean%20design&width=1200&height=700&seq=news-cover-mecha-retro&orientation=landscape",
    date: "2026-09-15",
    category: "作品回顾",
    author: "专栏作者 / 何宽",
    content: [
      { body: "《机械学园Z》完结已满一年，编号Z仍稳居平台角色人气榜前十。制作组回顾时提到，机体设计最难的部分不是“帅气”，而是让人相信它很旧。" },
      { heading: "旧，才是它的魅力", body: "设计团队在机体表面加入了超过两百处磨损细节，并刻意让装甲的接缝不完全对齐，让观众第一眼就能感受到时间的痕迹。" },
    ],
  },
  {
    id: "search-tips",
    title: "妖精动漫使用指南：如何用筛选快速找到适合你的番",
    summary: "从多维筛选到排序逻辑，这篇文章带你用最短路径找到想看的那一部。",
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20modern%20editorial%20illustration%20of%20anime%20poster%20grid%20on%20a%20light%20gray%20background%20with%20orange%20filter%20tags%20and%20a%20search%20field%2C%20minimal%20flat%20design%20with%20subtle%20layering&width=1200&height=700&seq=news-cover-search-guide&orientation=landscape",
    date: "2026-09-08",
    category: "网站指南",
    author: "妖精动漫编辑部",
    content: [
      { body: "妖精动漫目前收录的作品涵盖了国漫、日漫、韩漫等地区，并支持按类型、地区、年份与连载状态进行组合筛选。" },
      { heading: "三个最常用的组合", body: "想追新：地区不限 + 年份 2026 + 连载中 + 按更新时间排序。想补完：状态选择“已完结”。想快速找高分：先按评分排序，再用类型缩小范围。" },
      { body: "搜索页支持动漫与资讯联合搜索，输入“星空”既能找到《星空骑士》，也能找到相关剧集解读文章。" },
    ],
  },
];

export const getNewsById = (id?: string) =>
  newsList.find((item) => item.id === id);

export const categoryMeta: { slug: string; name: string; desc: string; icon: string; type: string; tint: string }[] = [
  { slug: "guoman", name: "国漫", desc: "国产动画新作与经典作品合集", icon: "ri-palette-line", type: "国漫", tint: "primary" },
  { slug: "riman", name: "日漫", desc: "日本制作社新番与高分番剧", icon: "ri-award-line", type: "日漫", tint: "accent" },
  { slug: "hanman", name: "韩漫改", desc: "韩国网漫改编动画与剧集", icon: "ri-book-open-line", type: "韩漫", tint: "secondary" },
  { slug: "kehuan", name: "科幻", desc: "星际、机甲与未来世界的想象", icon: "ri-rocket-2-line", type: "科幻", tint: "primary" },
  { slug: "qihuan", name: "奇幻", desc: "东方神话与异世界冒险", icon: "ri-magic-line", type: "奇幻", tint: "accent" },
  { slug: "zhiyu", name: "治愈", desc: "日常、美食与温柔的夏天", icon: "ri-heart-3-line", type: "治愈", tint: "secondary" },
  { slug: "maoxian", name: "冒险", desc: "远航、秘境与少年成长", icon: "ri-compass-3-line", type: "冒险", tint: "accent" },
  { slug: "wuxia", name: "武侠", desc: "江湖恩怨与剑谱传说", icon: "ri-sword-line", type: "武侠", tint: "primary" },
];

export const allTypes = ["全部", "科幻", "奇幻", "治愈", "机甲", "武侠", "悬疑", "日常", "冒险", "音乐"];
export const allRegions = ["全部", "国漫", "日漫", "韩漫"];
export const allYears = ["全部", "2026", "2025", "2024"];
export const allStatus = ["全部", "连载中", "已完结"];

export const formatViews = (num: number): string => {
  if (num >= 100000000) return `${(num / 100000000).toFixed(1)}亿`;
  if (num >= 10000) return `${(num / 10000).toFixed(1)}万`;
  return `${num}`;
};

export const fmtDate = (date: string): string => {
  const [, m, d] = date.split("-");
  return `${Number(m)}月${Number(d)}日`;
};